(function () {
  const TITLE_SELECTOR = '.custom-collection-subcategories__title';
  const MAX_SIZE = 13;
  const MIN_SIZE = 10;
  const STEP = 0.5;

  function fits(el) {
    return el.scrollHeight <= el.clientHeight + 1;
  }

  function updateTitle(titleEl) {
    let size = MAX_SIZE;
    titleEl.style.fontSize = size + 'px';

    while (!fits(titleEl) && size > MIN_SIZE) {
      size -= STEP;
      titleEl.style.fontSize = size + 'px';
    }
  }

  function updateAll(root) {
    root.querySelectorAll(TITLE_SELECTOR).forEach(updateTitle);
  }

  function init() {
    updateAll(document);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        updateAll(document);
      });
    }
  }

  let resizeTimer;

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', function (event) {
    updateAll(event.target);
  });
  window.addEventListener('resize', function () {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(function () {
      updateAll(document);
    }, 150);
  });
})();
